import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";

export default function AddPincode() {
  const [formData, setFormData] = useState({
    number: "",
    pinType: "",
  });
  const [disableBtn, setDisableBtn] = useState(false);

  const navigate = useNavigate()

  const handleInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableBtn(true);
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      console.log(formData);
      const formdata = new FormData();
      formdata.append("pinCode", formData.number);
      formdata.append("pinType", formData.pinType);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/pincode/add`,
        formdata,
        { headers }
      );
      // if (response.data.statusCode === 200) {
      //   toast.success(response?.data?.message);
      // } else {
      //   toast.error(response?.data?.message);
      // }
      toast(response?.data?.message);
      navigate(-1)
    } catch (error) {
      console.error(error);
      toast.error("Failed to add pincode. Please try again.", error);
    }
    setDisableBtn(false);
  };

  return (
    <>
      <Layout>
        <ToastContainer />
        <div>
          <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-medium">Add PinCode</h2>
            </div>
            <div className="mt-10" onSubmit={handleSubmit}>
              <form action="">
                <div className="">
                  <label htmlFor="" className="text-sm">
                    PinCode
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Pincode"
                    name="number"
                    value={formData.number}
                    onChange={handleInputChange}
                    maxLength={6}
                    required
                  />
                </div>
                <div className="mt-6">
                  <label htmlFor="" className="text-sm">
                    Pin Type
                  </label>{" "}
                  <br />
                  <select name="pinType" id="pinType" className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize" value={formData.pinType} onChange={handleInputChange}>
                    <option value="">Select Pin Type</option>
                    {
                        ["Home", "Office", "Other"].map((item)=>{
                            return <option value={item}>{item}</option>
                        })
                    }
                  </select>
                </div>
                <div className="mt-8 text-end">
                  <button
                    type="submit"
                    className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                    disabled={disableBtn}
                  >
                    <i className="fa fa-plus"></i>{" "}
                    {disableBtn ? "Adding ..." : "Add"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
